import React, { Fragment } from 'react';
import { Card, Row, Col } from 'antd';
import List from './components/List';
import ContainerBody from '@components/ContainerBody';
import Breadcrumb from '@components/Breadcrumb';
import { usePermission } from '@contexts/Auth/UsePermission';
import Page403 from '@page/Common/403/403';

const Warnings = () => {
  const { warning } = usePermission();

  if (!warning.view) {
    return (
      <ContainerBody>
        <Page403 />
      </ContainerBody>
    );
  }

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[{ name: 'Cảnh báo xảy ra', path: '/warnings' }]}
        />
      </div>
      <Row>
        <Col span={24}>
          <List />
        </Col>
      </Row>
    </ContainerBody>
  );
};

export default Warnings;
